import { ReportPostType, ReportValues } from "../../local_modules/reports/type/modal-for-report-type";
import { VoyageToastManager } from "../../local_modules/voy-toast/src/voy-toast-manager";
import { VoyageDialogPopupManager } from "../../local_modules/voyage-dialog-popup/src/voyage-dialog-popup-manager";
import { NotificationTypes } from "../services/types/vessel-notifications-services.types";
import { VesselNotificationsService } from "../services/vessel-notifications-service";
import { WeatherRouting } from "../services/weather-routing-reports-service";
import { EgNotification } from "./helper-notification";
import { AlertType, VesselAlertsModel } from "./vessel-alerts-model";
import { WeatherRoutingBase } from "./weather-routing-reports-model";

const THIRTY_MINS = 1000 * 60 * 1;

export const SHOW_WNI_REPORT_POPUP = 'show-report-popup';
export const SHOW_MINIMIZED_REPORT = 'show-minimized-report';

export class WeatherRoutingModelImpl extends WeatherRoutingBase {

    constructor() {
        super();
        this.checkForReportNotification = this.checkForReportNotification.bind(this);
        this.showReportPopup = this.showReportPopup.bind(this);
        this.constructReportMessage = this.constructReportMessage.bind(this);

        setTimeout(() => {
            this.checkForReportNotification();
        }, 3000);

        // check every 5 minutes if there is any new notification
        setInterval(() => {
            this.checkForReportNotification()
        }, THIRTY_MINS);
    }


    constructReportMessage(reportType: string): string {
        switch (reportType) {
            case 'Departure':
                return 'Please submit your SOSP report';
            case 'Arrival':
                return 'Please submit your EOSP report';
            case 'Noon':
                return 'Please submit your Noon report';
            default:
                return 'Please submit your report';
        }
    }

    async shouldCreateDepartureReportNotification() {
        const notifications = await VesselNotificationsService.fetchActiveNotifications(NotificationTypes.WniReports);
        if(!notifications || notifications.length === 0) return true;
        const notificationData = notifications[0]
        const notification = JSON.parse(notificationData.data);

        return notification?.reportType !== 'Departure';
    }

    private async checkForReportNotification() {

        const notifications = await VesselNotificationsService.fetchActiveNotifications(NotificationTypes.WniReports);
        if(!notifications || notifications.length === 0) return;
        const notificationData = notifications[0]
        const notification = JSON.parse(notificationData.data);
        const scheduleId = notification.scheduleID;
        const reportType = notification.reportType;
        const notificationId = notificationData.id;

        if (!notification) return;

        const title = notification?.reportType === 'Departure' ? 'SOSP Report' : notification?.reportType === 'Noon' ? 'Noon Report' : 'EOSP Report';

            VesselAlertsModel!.addAlert((<any>window)["appenv"].vesselIMONumber, {
                title: title,
                message: this.constructReportMessage(reportType),
                id: notificationId,
                type: AlertType.WNIReports,
                reportId: notification.reportId,
                reportType: reportType,
                scheduleId: scheduleId,
            })

        
         // Get existing reports from localStorage
         const existingWniNotifications = JSON.parse(localStorage.getItem('WNIReportsNotifications') || '{}');
                
         const existingScheduleData = existingWniNotifications[scheduleId] || {
             Departure: "",
             Arrival: "",
             Noon: ""
         };

         const updatedWniNotifications = {
             ...existingWniNotifications,
             [scheduleId]: {
                 ...existingScheduleData,
                 [reportType]: notificationId 
             }
         };

        localStorage.setItem('WNIReportsNotifications', JSON.stringify(updatedWniNotifications));
    }
    async sospReportFetch(scheduleId: string): Promise<ReportValues | undefined> {
        try {
            const sospReport = await WeatherRouting.getSospReport(scheduleId);
            return sospReport;
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            return
        }
    }

    async departureReportSend(scheduleId: string):  Promise<ReportPostType> {
        try {
            const res = await WeatherRouting.postDepartureReport(scheduleId);
            return res
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            return { isSuccess: false, id: 0 }
        }
    }

    async departureReportPut(payload: ReportValues):  Promise<any> {
        try {
            const departureReport = await WeatherRouting.putDepartureReport(payload);
            return departureReport
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            return { isSuccess: false, id: 0 }
        }
    }

    async departureReportSubmit(payload: ReportValues):  Promise<any> {
        try {
            const departureReport = await WeatherRouting.submitDepartureReport(payload);
            if(departureReport.isSuccess) {
                VoyageToastManager.createToast({
                    message: 'Departure Report has been submitted successfully',
                    type: 'success'
                })
            }
            return departureReport
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            return { isSuccess: false, id: 0 }
        }
    }

    async reportIdPaginationFetch(scheduleId:string):Promise<any>{
        try {
            const responseReportIds = await WeatherRouting.getReportIdPagination(scheduleId);
            return responseReportIds;
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            return []
        }
    }

    async noonReportFetch(scheduleId: string, id: number): Promise<ReportValues | undefined> {
        try {
            const noonReport = await WeatherRouting.getNoonReport(scheduleId, id);
            return noonReport;
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            return;
        }
    }

    async noonReportSend(scheduleId: string): Promise<ReportPostType> {
        try {
            const res = await WeatherRouting.postNoonReport(scheduleId);
            return res
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            return { isSuccess: false, id: 0 }
        }
    }

    async noonReportPut(payload: ReportValues):  Promise<any> {
        try {
            const noonReport = await WeatherRouting.putNoonReport(payload);
            return noonReport
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            return { isSuccess: false, id: 0 }
        }
    }

    async noonReportSubmit(payload: ReportValues):  Promise<any> {
        try {
            const res = await WeatherRouting.submitNoonReport(payload);
            if(res.isSuccess) {
                VoyageToastManager.createToast({
                    message: 'Noon Report has been submitted successfully',
                    type: 'success'
                })
            }
            return res
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            return { isSuccess: false, id: 0 }
        }
    }

    async eospReportFetch(scheduleId: string): Promise<ReportValues | undefined> {
        try {
            const eospReport = await WeatherRouting.getEospReport(scheduleId);
            return eospReport;
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            return
        }
    }

    async arrivalReportSend(scheduleId: string):  Promise<ReportPostType> {
        try {
            const res = await WeatherRouting.postArrivalReport(scheduleId);
            return res
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            VoyageDialogPopupManager.createDialog({
                headerText: 'Error fetching eosp report',
                bodyText: 'There has been an error fetching the EOSP report. Please try again later.',
                acceptButtonText: 'Ok',
            })
            return { isSuccess: false, id: 0 }
        }
    }

    async arrivalReportPut(payload: ReportValues):  Promise<any> {
        try {
            const arrivalReport = await WeatherRouting.putArrivalReport(payload);
            return arrivalReport
        } catch (err) {
            console.error('Error fetching eosp report:', err);
            return { isSuccess: false, id: 0 }
        }
    }

    async arrivalReportSubmit(payload: ReportValues):  Promise<any> {
        try {
            const res = await WeatherRouting.submitArrivalReport(payload);
            if(res.isSuccess) {
                VoyageToastManager.createToast({
                    message: 'Arrival Report has been submitted successfully',
                    type: 'success'
                })
            }
            return res
        } catch (err) {
            console.error('Error fetching eosp report:', err)
            return { isSuccess: false, id: 0 }
        }
    }

    showReportPopup(reportType: string, scheduleId: string, reportId: number,minimizedPopUp:boolean) {
        this.dispatchEvent(new CustomEvent(SHOW_WNI_REPORT_POPUP, {
            detail: {
                reportType,
                scheduleId,
                reportId,
                minimizedPopUp,
                fromNotification: false,
            }
        }));
    }

    async checkIfReportExists(scheduleId: string, reportType: string): Promise<any> {

        const getReport = await WeatherRouting.checkIfReportExists(scheduleId, reportType);

        return getReport
    }
    
}
